var _path, _polygon, _circle, _path2, _path3, _path4, _path5, _path6, _polygon2, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _polyline;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 788.66998,
    height: 600.83351,
    viewBox: "0 0 788.66998 600.83351",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0,544.59352c0,.65997.53,1.19,1.19,1.19h786.28998c.65997,0,1.19-.53003,1.19-1.19s-.53003-1.19-1.19-1.19H1.19c-.66,0-1.19.53003-1.19,1.19Z",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "432.06 207.90348 440.17999 157.19349 385.41 134.88349 377.29999 211.95349 432.06 207.90348",
    fill: "#a0616a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 418.22,
    cy: 117.64349,
    r: 55.85,
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m413.76999,42.56349c1.62.94,3.78-.48,4.29999-2.28s-.09-3.71-.67999-5.48c-1-2.97-2.01001-5.95-3.01001-8.92-2.14001-6.33-4.41-12.88-9.03-17.7-6.98999-7.27-18.09-9.12-28.07999-7.78-12.82999,1.72-25.5,8.67-31.45999,20.16-5.97,11.49-3.42999,27.53,7.35999,34.7-15.37,17.61-20.73001,37.25-19.88,60.61.85001,23.36001,26.29999,44.86001,42.91,61.32,3.70999-2.25,7.07999-12.78,5.04001-16.61-2.04001-3.83.88-8.25999-1.64001-11.78-2.51999-3.52-4.64001,2.09-2.07999-1.42,1.60999-2.21001-4.67999-7.3-2.28-8.62,11.57999-6.39999,15.42999-20.84,22.70999-31.89,8.76999-13.33,23.79001-22.36,39.67999-23.86,8.75-.83,18,.67,25.17001,5.75s11.82001,14.16,10.16,22.8c4.31-4.38,6.45001-10.79,5.64001-16.87s-4.54999-11.72-9.85999-14.81c3.22-10.66.45999-22.92-7.01999-31.17-7.48001-8.25-37.84-6.84-48.76001-4.67",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m412.07001,83.32349c-14.47,1.56-24.92001,14.1-33.73999,25.67-5.07999,6.67-10.41,14.04-10.28,22.43.13,8.48,5.79999,15.75,8.51001,23.78999,4.42999,13.14.10999,28.75999-10.42999,37.75999,10.42001,1.98,21.67999-5.83,23.48001-16.28,2.09-12.16-7.13-23.89999-6.04001-36.2.95999-10.83,9.5-19.17,16.75-27.27s14.07001-18.85,10.73001-29.2",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m414.84,594.83351s-121,12-130-2,122.79001-28,122.79001-28l7.20999,30Z",
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m337.69,370.49348l-2.5,13.26999c6.81,10.04999,7.45999,20.67001,3.5,31.73001l138,1c-1.48001-14.95001-3.10999-30.97,2.57001-45.66l-141.57001-.34Z",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m563.72998,469.16349l-50.04999-40.04001c-6.64999-5.32001-10.95999-13.23001-11.81-21.70001l-7.70999-76.26999,45.94998-15.32001,11.08002,75.51999,27.60999,62.75-15.06,15.06h-.01001v.00003Z",
    fill: "#a0616a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "372.19 202.99349 439.19 199.99349 510.19 233.81349 481.19 371.99348 334.19 382.99348 314.19 229.99349 372.19 202.99349",
    fill: "#00b0ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m479.26001,403.83348c10.07001,13.26999,14.29001,45.22,18.57001,77,0,0-186-1-187-1s28.42999-67,28.42999-67l140-9h0Z",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m485.34,472.3535l12.5,8.48001s176.99997-12,161.99997,44-62,65-62,65l-190,11-2-31s-183,41-200-43,105-47,105-47l174.5-7.48001h.00003Z",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m410.64999,538.83351s4.19-22,34.19-13,47,21,47,21l-72,18-9.19-26Z",
    fill: "#a0616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m485.69,231.49349s34-12,47,26.99998c13,39,10,71,10,71l-50,16-7-114h0v.00002Z",
    fill: "#00b0ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m252.53999,475.25349l-10.91-19.22,23.56999-58.67001,11.07999-75.53,45.95001,15.32001-7.81,77.19998c-.79999,7.89001-4.81,15.25-11,20.20001l-50.88,40.70999h0l.00002-.00998Z",
    fill: "#a0616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m330.69,231.49349s-34-12-47,26.99998c-13,39-10,71-10,71l50,16,7-114h0v.00002Z",
    fill: "#00b0ff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 578.19,
    cy: 442.49348,
    rx: 24,
    ry: 35.5,
    fill: "#a0616a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.19,
    cy: 448.49348,
    rx: 24,
    ry: 35.5,
    fill: "#a0616a"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "332.84 507.83348 419.84 532.83351 436.84 562.83351 404.32999 569.83351",
    fill: "#2f2e41"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.6aa5436a5e305f635084407e20ccf248.svg";
export { ForwardRef as ReactComponent };